<template>
    <div class="row p-1 cartao-semsa">
        <div class="col-12">

            <div class="container mt-2 mb-4">
                <center><img style="width: 150px; height: 150px;"
                        :src="dados.foto ? `data:image/jpeg;base64,${dados.foto}` : '@/assets/img/anime3.png'" />
                </center>
                <div class="col-12 text-left">
                    <div class="row">
                        <div class="col-12 mt-4 mt-sm-0">
                            <h4 slot="header" class="card-title font-weight-bold">DADOS CADASTRAIS</h4>
                            <p class="font-weight-bold"> Nome: <span class="font-weight-normal">{{ dados.nome }}</span></p>
                            <p class="font-weight-bold"> Endereço: <span class="font-weight-normal">{{ dados.endereco ?
                                dados.endereco : '-' }}</span></p>
                            <p class="font-weight-bold"> Cidade: <span class="font-weight-normal">{{ dados.cidade ?
                                dados.cidade : '-' }}</span> CEP: <span class="font-weight-normal">{{ dados.cep ?
        dados.cep : '-' }}</span>
                                TEL.: <span class="font-weight-normal">{{ dados.telefone ? dados.telefone : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Data de Nascimento: <span class="font-weight-normal">{{
                                dados.data_nascimento ?
                                dados.data_nascimento : '-' }}</span></p>
                            <p class="font-weight-bold"> Identidade: <span class="font-weight-normal">{{ dados.rg ? dados.rg
                                : '-' }}</span></p>
                            <p class="font-weight-bold"> CPF: <span class="font-weight-normal">{{ dados.cpf ? dados.cpf :
                                '-' }}</span></p>
                            <p class="font-weight-bold"> Título de Eleitor: <span class="font-weight-normal">{{
                                dados.titulo_numero ? dados.titulo_numero :
                                '-' }}</span> Zona: <span class="font-weight-normal">{{
        dados.titulo_zona
        ?
        dados.titulo_zona : '-' }}</span> Seção: <span class="font-weight-normal">{{
        dados.titulo_secao ? dados.titulo_secao : '-' }}</span></p>
                            <p class="font-weight-bold"> Carteira de Reservista: <span class="font-weight-normal">{{
                                dados.cert_reservista_ra ?
                                dados.cert_reservista_ra : '-' }}</span>
                                Categoria:
                                <span class="font-weight-normal">{{ dados.certificado_reservista_categoria ?
                                    dados.certificado_reservista_categoria : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> CTPS: <span class="font-weight-normal">{{ dados.ctps ? dados.ctps :
                                '-' }}</span> Série: <span class="font-weight-normal">{{
        dados.ctps_serie ? dados.ctps_serie :
        '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Pis/Pasep: <span class="font-weight-normal">{{ dados.numero_pis ?
                                dados.numero_pis : '-' }}</span></p>
                            <p class="font-weight-bold"> Filiação: Pai: <span class="font-weight-normal">{{
                                dados.filiacao_pai ? dados.filiacao_pai : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Mãe: <span class="font-weight-normal">{{ dados.filiacao_mae ?
                                dados.filiacao_mae : '-' }}.</span></p>
                            <p class="font-weight-bold"> Grau de Instrução: <span class="font-weight-normal">{{
                                dados.escolaridade ? dados.escolaridade : '-'
                            }}</span></p>
                            <p class="font-weight-bold"> Data de Admissão: <span class="font-weight-normal">{{
                                dados.data_adimissao ? dados.data_adimissao :
                                '-' }}</span></p>
                            <p class="font-weight-bold"> Horas Contratadas mês: <span class="font-weight-normal">{{
                                dados.horas_contradadas_mes ?
                                dados.horas_contradadas_mes : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Valor do Plano de Saúde: <span class="font-weight-normal">{{
                                dados.valor_plano_saude ?
                                dados.valor_plano_saude : '-' }}</span></p>
                            <p class="font-weight-bold"> Banco: <span class="font-weight-normal">{{ dados.banco ?
                                dados.banco : '-' }}</span> conta bancária: <span class="font-weight-normal">{{
        dados.nr_conta_bancaria ?
        dados.nr_conta_bancaria : '-' }}</span></p>
                            <p class="font-weight-bold"> Função: <span class="font-weight-normal">{{ dados.funcao ?
                                dados.funcao : '-' }}</span> Departamento: <span class="font-weight-normal">{{
        dados.departamento ?
        dados.departamento : '-' }}</span></p>
                            <p class="font-weight-bold"> Empresa Contratante: <span class="font-weight-normal">{{
                                dados.fantasia ? dados.fantasia : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Contribuição Sindical: Data: <span class="font-weight-normal">{{
                                dados.contribuicao_sindical_data ?
                                dados.contribuicao_sindical_data
                                : '-' }}</span> Valor: <span class="font-weight-normal">{{
        dados.contribuicao_sindical_valor ? dados.contribuicao_sindical_valor :
        '-'
    }}</span>
                            </p>
                            <p class="font-weight-bold"> Configurações do sistema:</p>
                            <p class="font-weight-bold"> Feriados serão: <span class="font-weight-normal">{{ dados.feriado ?
                                dados.feriado : '-' }}</span> Folgas
                                serão Extras: <span class="font-weight-normal">{{ dados.folga ? dados.folga : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Sábados serão
                                Extras: <span class="font-weight-normal">{{ dados.sabado ? dados.sabado : '-' }}</span>
                                Domingo serão
                                Extras:
                                <span class="font-weight-normal">{{ dados.domingo ? dados.domingo : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Categoria Banco de Hora: <span class="font-weight-normal">{{
                                dados.bancoHora ? dados.bancoHora : '-' }}</span> Categoria Pré-assinalação:
                                <span class="font-weight-normal">{{ dados.assinalacao ? dados.assinalacao : '-' }}</span>
                            </p>
                            <p class="font-weight-bold"> Permite Registrar Ponto Off-line: <span
                                    class="font-weight-normal">{{ dados.offlineapp ? dados.offlineapp : '-' }}</span>
                                Leitura de QRCode no App
                                celular: <span class="font-weight-normal">{{ dados.qrcode ? dados.qrcode : '-' }}</span></p>
                            <br>
                            <p> Informações extraídas do sistema em: {{ moment().format("DD/MM/YYYY") }} às
                                {{ moment().format("HH:mm") }} </p>

                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-sm-5 col-12 text-center border-top border-dark">
                            <p>EMPREGADOR</p>

                        </div>
                        <div class="offset-sm-2 col-sm-5 col-12 text-center border-top border-dark">
                            <p>EMPREGADO</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import { AbonosInserir, OcorrenciasInserir } from "./index";
import Modal from "@/components/Modal.vue";
import moment from "moment";

export default {
    name: "BaseCartaoPontoSemsa",
    components: {
        Loading,
        Modal,
        AbonosInserir,
        OcorrenciasInserir
    },
    props: {
        dados: Object,
    },
    methods: {
        moment: function (data) {
            return moment(data);
        }
    },
};
</script>
<style>
.faltas {
    width: 25px;
    height: 20px;
    background: #db6153;
    border-radius: 7px 7px 7px 7px;
    -moz-border-radius: 7px 7px 7px 7px;
    -webkit-border-radius: 7px 7px 7px 7px;
    border: none;
    margin-right: 5px;
}

.tb-falta {
    background: #db6153;
}

.tb-feriados {
    background: #e37acc;
}

.tb-folgas {
    background: #6ece87;
}

.tb-ferias {
    background: #7a93e3;
}

.feriados {
    width: 25px;
    height: 20px;
    background: #e37acc;
    border-radius: 7px 7px 7px 7px;
    -moz-border-radius: 7px 7px 7px 7px;
    -webkit-border-radius: 7px 7px 7px 7px;
    border: none;
    margin-right: 5px;
}

.ferias {
    width: 25px;
    height: 20px;
    background: #7a93e3;
    border-radius: 7px 7px 7px 7px;
    -moz-border-radius: 7px 7px 7px 7px;
    -webkit-border-radius: 7px 7px 7px 7px;
    border: none;
    margin-right: 5px;
}

.folgas {
    width: 25px;
    height: 20px;
    background: #6ece87;
    border-radius: 7px 7px 7px 7px;
    -moz-border-radius: 7px 7px 7px 7px;
    -webkit-border-radius: 7px 7px 7px 7px;
    border: none;
    margin-right: 5px;
}

.batidas {
    margin-right: 5px;
}
</style>
  
<style>
.cartao-semsa {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}

.label-assinatura {
    display: inline-flex;
    min-width: 60px;
}

.label-horario {
    display: inline-flex;
    min-width: 40px;
}

.assinatura {
    margin-left: 2px;
    display: inline-flex;
    min-width: 40%;
    border-bottom: 1px solid black;
    line-height: 14px;
    padding-left: 4px;
}

.assinatura-matricula {
    display: inline-flex;
    min-width: 10%;
    border-bottom: 1px solid black;
    line-height: 14px;
    padding-left: 4px;
}

.horario-extra {
    margin-left: 2px;
    display: inline-flex;
    min-width: 30%;
    border-bottom: 1px solid black;
    line-height: 14px;
    padding-left: 4px;
}

.semsa-title {
    font-weight: 600;
    line-height: 6px;
}

.semsa-table {
    margin-top: 20px;
}

.semsa-table table {
    width: 100%;
}

.semsa-table th {
    background-color: gray;
}

.semsa-table td {
    font-weight: 600;
}

.table-bordered th,
.table-bordered td {
    border: 1px solid black;
    color: black;
}
</style>
  